export const cols = [
  {
    key: 'subordinateInfo',
    label: '',
    dataType: 'FlowMainSub',
    sortable: false,
    width: 26,
    align: 'left',
    showOverflowTooltip: true,
  },
  {
    key: 'tradingProgressStatusCd',
    label: ' ',
    dataType: 'TradingStatusIcon',
    sortable: true,
    width: 40,
    align: 'right',
    showOverflowTooltip: true,
  },
  {
    key: 'tradingFlowId',
    label: 'Trading/Flow ID',
    dataType: 'TradingFlowId',
    sortable: true,
    width: 180,
    showOverflowTooltip: true,
  },
  {
    key: 'tradingManageName',
    label: 'Flow Name',
    dataType: 'FlowDetail',
    sortable: true,
    width: 320,
    showOverflowTooltip: true,
  },
  {
    key: 'contractNo',
    label: 'Contract No',
    dataType: 'String',
    sortable: true,
    width: 140,
    showOverflowTooltip: true,
  },
  {
    key: 'contractDate',
    label: 'Contract Date',
    dataType: 'Date',
    sortable: true,
    width: 140,
    showOverflowTooltip: true,
  },
  {
    key: 'invoiceNo',
    label: 'Invoice No',
    dataType: 'String',
    sortable: true,
    width: 320,
    showOverflowTooltip: true,
  },
  {
    key: 'sellerName',
    label: 'Seller',
    dataType: 'String',
    sortable: true,
    width: 120,
    showOverflowTooltip: true,
  },
  {
    key: 'buyerName',
    label: 'Buyer',
    dataType: 'String',
    sortable: true,
    width: 120,
    showOverflowTooltip: true,
  },
  {
    key: 'contractGroupOfGoods',
    label: 'Main Goods',
    dataType: 'String',
    sortable: true,
    width: 150,
    showOverflowTooltip: true,
  },
  {
    key: 'contractTotalQuantity',
    label: 'Total Quantity',
    dataType: 'Quantity',
    target: 'contractQuantityUnit',
    sortable: true,
    width: 140,
    align: 'right',
    showOverflowTooltip: true,
  },
  {
    key: 'contractTotalAmount',
    label: 'Total Amount',
    dataType: 'Currency',
    target: 'contractCurrencyId',
    sortable: true,
    width: 140,
    align: 'right',
    showOverflowTooltip: true,
  },
  {
    key: 'nameOfVessel',
    label: 'Vessel Name',
    dataType: 'String',
    sortable: true,
    width: 140,
    showOverflowTooltip: true,
  },
  {
    key: 'blNo',
    label: 'B/L No',
    dataType: 'String',
    sortable: true,
    width: 100,
    showOverflowTooltip: true,
  },
  {
    key: 'vesselBookingNo',
    label: 'Booking No',
    dataType: 'String',
    sortable: true,
    width: 120,
    showOverflowTooltip: true,
  },
  {
    key: 'numberOfContainers',
    label: 'No of Containers',
    dataType: 'String',
    sortable: true,
    width: 150,
    showOverflowTooltip: true,
  },
  {
    key: 'blDate',
    label: 'ETD/BL Date',
    dataType: 'Date',
    sortable: true,
    width: 120,
    showOverflowTooltip: true,
  },
  {
    key: 'eta',
    label: 'ETA',
    dataType: 'Date',
    sortable: true,
    width: 100,
    showOverflowTooltip: true,
  },
  {
    key: 'dischargingCurrentEta',
    label: 'Discharging Current ETA',
    dataType: 'Date',
    sortable: true,
    width: 200,
    showOverflowTooltip: true,
  },
  {
    key: 'portOfLoadingName',
    label: 'Port of Loading',
    dataType: 'String',
    sortable: true,
    width: 200,
    showOverflowTooltip: true,
  },
  {
    key: 'portOfDischargingName',
    label: 'Port of Discharging',
    dataType: 'String',
    sortable: true,
    width: 200,
    showOverflowTooltip: true,
  },
  {
    key: 'imRequestDeclarationDate',
    label: 'Im Request Declaration Date',
    dataType: 'Date',
    sortable: true,
    width: 220,
    showOverflowTooltip: true,
  },
  {
    key: 'deliveryDate',
    label: 'Delivery Date',
    dataType: 'Date',
    sortable: true,
    width: 140,
    showOverflowTooltip: true,
  },
  {
    key: 'devanningPlace',
    label: 'Place of Devanning',
    dataType: 'String',
    sortable: true,
    width: 200,
    showOverflowTooltip: true,
  },
  {
    key: 'warehouse',
    label: 'Warehouse',
    dataType: 'String',
    sortable: true,
    width: 200,
    showOverflowTooltip: true,
  },
  {
    key: 'freeTime',
    label: 'Free Time',
    dataType: 'Date',
    sortable: true,
    width: 110,
    showOverflowTooltip: true,
  },
  {
    key: 'exRequestDeclarationDate',
    label: 'Ex Request Declaration Date',
    dataType: 'Date',
    sortable: true,
    width: 220,
    showOverflowTooltip: true,
  },
  {
    key: 'vanningDate',
    label: 'Vanning Date',
    dataType: 'Date',
    sortable: true,
    width: 140,
    showOverflowTooltip: true,
  },
  {
    key: 'vanningPlace',
    label: 'Place of Vanning',
    dataType: 'String',
    sortable: true,
    width: 200,
    showOverflowTooltip: true,
  },
  {
    key: 'cyCutDate',
    label: 'CY CUT',
    dataType: 'Date',
    sortable: true,
    width: 100,
    showOverflowTooltip: true,
  },
  {
    key: 'tradingChannelInfo.tradingChannelNo',
    label: 'TC No',
    dataType: 'String',
    sortable: true,
    width: 150,
    showOverflowTooltip: true,
  },
  {
    key: 'flowCreateDate',
    label: 'Create Datetime',
    dataType: 'DateTime',
    sortable: true,
    width: 180,
    showOverflowTooltip: true,
  },
  {
    key: 'flowUpdateDate',
    label: 'Update Datetime',
    dataType: 'DateTime',
    sortable: true,
    width: 180,
    showOverflowTooltip: true,
  },
  {
    key: 'otherTradingFlg',
    label: '',
    dataType: 'OtherTrading',
    width: 40,
    showOverflowTooltip: true,
  },
];

export const tableData = [
  {
    otherTradingFlg: 0,
    otherTradingName: null,
    otherTradingId: null,
    tradingId: 'T202505210000007',
    tradingFlowId: '1',
    tradingName: 'Harness（TOYOTA US向け）',
    tradingManageName: '6月輸出',
    tradeTypeCd: 1,
    tradeTypeCdDisplay: 1,
    tradingSubmitStatusCd: 2,
    tradingProgressStatusCd: 1,
    ownerSectionId: 'SE00000713',
    ownerSectionShortName: 'Sec1',
    ownerSectionName: 'Sec1',
    ownerCompanyId: 'CO00000262',
    ownerCompanyShortName: 'Exporter1_forDevCS',
    ownerCompanyName: 'Exporter1_forDevCS',
    ownerCompanyIcon: '/files/tw/companies/default/icon.png',
    flowCreateDate: '2025-05-21T04:52:09Z',
    flowUpdateDate: '2025-05-21T10:21:48Z',
    editableFlg: 1,
    deletableFlg: 0,
    visibleFlg: 1,
    flowDetailViewableFlg: 1,
    entityStatus: [
      {
        entityId: 'ESC000000011164',
        entityTypeCd: 1,
        entityProgressStatusCd: 1,
        no: 'COS',
        processStatus: [
          {
            processId: 'COPO',
            processSeq: 1,
            processSortNo: 100,
            processName: 'Send Purchase Order',
            processType: 'PT_COPO',
            processProgressStatusCd: 1,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'COCOS',
            processSeq: 1,
            processSortNo: 110,
            processName: 'Issue Contract',
            processType: 'PT_COCOS',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [],
      },
      {
        entityId: 'ELC000000001620',
        entityTypeCd: 2,
        entityProgressStatusCd: 0,
        no: 'INV',
        processStatus: [
          {
            processId: 'LCACCEPT',
            processSeq: 1,
            processSortNo: 210,
            processName: 'Store Letter of Credit',
            processType: 'PT_LCACCEPT',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202505210000007',
            prevTradingFlowId: '1',
            prevEntityId: 'ESC000000011164',
            prevEntityTypeCd: 1,
          },
        ],
      },
      {
        entityId: 'EAG000000001223',
        entityTypeCd: 8,
        entityProgressStatusCd: 0,
        no: 'INV',
        processStatus: [
          {
            processId: 'TPARB',
            processSeq: 1,
            processSortNo: 320,
            processName: 'Prepare Shipment',
            processType: 'PT_TPATPRB',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202505210000007',
            prevTradingFlowId: '1',
            prevEntityId: 'ELC000000001620',
            prevEntityTypeCd: 2,
          },
        ],
      },
      {
        entityId: 'EEC000000013665',
        entityTypeCd: 3,
        entityProgressStatusCd: 1,
        no: 'INV',
        processStatus: [
          {
            processId: 'ECREQ04',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'ECREQ05',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'ECREQ01',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 6,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'ECREQ02',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'ECREQ03',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'ECPERMIT',
            processSeq: 1,
            processSortNo: 430,
            processName: 'Store Ex. Customs Permit',
            processType: 'PT_ECPERMIT',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202505210000007',
            prevTradingFlowId: '1',
            prevEntityId: 'EAG000000001223',
            prevEntityTypeCd: 8,
          },
        ],
      },
      {
        entityId: 'ETP000000008448',
        entityTypeCd: 5,
        entityProgressStatusCd: 0,
        no: 'INV',
        processStatus: [
          {
            processId: 'TPRB',
            processSeq: 1,
            processSortNo: 705,
            processName: 'Request Booking',
            processType: 'PT_TPATPRB',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'TPRBL',
            processSeq: 1,
            processSortNo: 710,
            processName: 'Request Bill of Lading',
            processType: 'PT_TPRBL',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'TPBLI02',
            processSeq: 1,
            processSortNo: 720,
            processName: 'Bill of Lading Information',
            processType: 'PT_TPBLI',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'TPBLI01',
            processSeq: 1,
            processSortNo: 720,
            processName: 'Bill of Lading Information',
            processType: 'PT_TPBLI',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'TPBL',
            processSeq: 1,
            processSortNo: 740,
            processName: 'Store Bill of Lading',
            processType: 'PT_TPBL',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202505210000007',
            prevTradingFlowId: '1',
            prevEntityId: 'EEC000000013665',
            prevEntityTypeCd: 3,
          },
        ],
      },
      {
        entityId: 'EMI000000008627',
        entityTypeCd: 4,
        entityProgressStatusCd: 0,
        no: 'INV',
        processStatus: [
          {
            processId: 'MIRIP01',
            processSeq: 1,
            processSortNo: 500,
            processName: 'Request Insurance Policy',
            processType: 'PT_MIRIP',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'MIRIP02',
            processSeq: 1,
            processSortNo: 501,
            processName: 'Request Insurance Policy',
            processType: 'PT_MIRIP',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'MIRIP03',
            processSeq: 1,
            processSortNo: 502,
            processName: 'Request Insurance Policy',
            processType: 'PT_MIRIP',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'MIIP',
            processSeq: 1,
            processSortNo: 520,
            processName: 'Store Insurance Policy',
            processType: 'PT_MIIP',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202505210000007',
            prevTradingFlowId: '1',
            prevEntityId: 'ETP000000008448',
            prevEntityTypeCd: 5,
          },
        ],
      },
      {
        entityId: 'EFD000000008244',
        entityTypeCd: 6,
        entityProgressStatusCd: 0,
        no: 'INV',
        processStatus: [
          {
            processId: 'FDCRTDOC',
            processSeq: 1,
            processSortNo: 810,
            processName: 'Create Shipping Documents',
            processType: 'PT_FDCRTDOC',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'FDCOR01',
            processSeq: 1,
            processSortNo: 820,
            processName: 'Request Certificate of Origin',
            processType: 'PT_FDCOR',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'FDCOI01',
            processSeq: 1,
            processSortNo: 821,
            processName: 'Issue Certificate of Origin',
            processType: 'PT_FDCOI',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'FDCOR02',
            processSeq: 1,
            processSortNo: 822,
            processName: 'Request Certificate of Origin',
            processType: 'PT_FDCOR',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'FDCOI02',
            processSeq: 1,
            processSortNo: 823,
            processName: 'Issue Certificate of Origin',
            processType: 'PT_FDCOI',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'FDCOR03',
            processSeq: 1,
            processSortNo: 824,
            processName: 'Request Certificate of Origin',
            processType: 'PT_FDCOR',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'FDCOI03',
            processSeq: 1,
            processSortNo: 825,
            processName: 'Issue Certificate of Origin',
            processType: 'PT_FDCOI',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'FDCOR04',
            processSeq: 1,
            processSortNo: 826,
            processName: 'Request Certificate of Origin',
            processType: 'PT_FDCOR',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'FDCOI04',
            processSeq: 1,
            processSortNo: 827,
            processName: 'Issue Certificate of Origin',
            processType: 'PT_FDCOI',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'FDCOR05',
            processSeq: 1,
            processSortNo: 828,
            processName: 'Request Certificate of Origin',
            processType: 'PT_FDCOR',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'FDCOI05',
            processSeq: 1,
            processSortNo: 829,
            processName: 'Issue Certificate of Origin',
            processType: 'PT_FDCOI',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'FDDOC',
            processSeq: 1,
            processSortNo: 830,
            processName: 'Send Shipping Documents',
            processType: 'PT_FDDOC',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202505210000007',
            prevTradingFlowId: '1',
            prevEntityId: 'EMI000000008627',
            prevEntityTypeCd: 4,
          },
        ],
      },
      {
        entityId: 'EIC000000010672',
        entityTypeCd: 7,
        entityProgressStatusCd: 1,
        no: 'INV',
        processStatus: [
          {
            processId: 'ICREQ05',
            processSeq: 1,
            processSortNo: 900,
            processName: 'Imp. Instruction',
            processType: 'PT_ICREQ',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'ICREQ01',
            processSeq: 1,
            processSortNo: 900,
            processName: 'Imp. Instruction',
            processType: 'PT_ICREQ',
            processProgressStatusCd: 1,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'ICREQ02',
            processSeq: 1,
            processSortNo: 900,
            processName: 'Imp. Instruction',
            processType: 'PT_ICREQ',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'ICREQ03',
            processSeq: 1,
            processSortNo: 900,
            processName: 'Imp. Instruction',
            processType: 'PT_ICREQ',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'ICREQ04',
            processSeq: 1,
            processSortNo: 900,
            processName: 'Imp. Instruction',
            processType: 'PT_ICREQ',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'ICPERMIT',
            processSeq: 1,
            processSortNo: 930,
            processName: 'Store Im. Customs Permit',
            processType: 'PT_ICPERMIT',
            processProgressStatusCd: 6,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202505210000007',
            prevTradingFlowId: '1',
            prevEntityId: 'EFD000000008244',
            prevEntityTypeCd: 6,
          },
        ],
      },
    ],
    subordinateInfo: {
      parentFlg: 0,
      subFlg: 0,
      combineFlg: 0,
      parentFlowInfo: [
        {
          parentTradingId: null,
          parentFlowId: null,
          mainCombineFlg: null,
        },
      ],
    },
    tradingChannelInfo: {
      flowType: null,
      tradingChannelNo: 'TC20250521000007',
    },
    invoiceNo: 'INV',
    contractNo: 'COS',
    contractDate: null,
    sellerName: 'SELLER',
    buyerName: 'BUYER',
    contractGroupOfGoods: 'HARNESS',
    contractTotalQuantity: 1200,
    contractTotalQuantityUnitId: 'H87',
    contractQuantityUnit: 'Pieces',
    contractTotalAmount: 260000,
    contractCurrencyId: 'USD',
    paymentTermsCd: null,
    deliveryTermsCd: 'CIF',
    blDate: '2025-04-01',
    eta: '2025-06-02',
    dischargingEta: '2025-06-02',
    nameOfVessel: 'VESSEL NAME',
    blNo: null,
    vesselBookingNo: 'BKGNO',
    numberOfContainers: 1,
    dischargingCurrentEta: '2025-06-05',
    portOfLoadingName: null,
    portOfDischargingName: null,
    imRequestDeclarationDate: null,
    deliveryDate: '2025-07-24',
    devanningPlace: null,
    warehouse: null,
    freeTime: null,
    exRequestDeclarationDate: null,
    vanningDate: null,
    vanningPlace: null,
    cyCutDate: null,
  },
  {
    otherTradingFlg: 0,
    otherTradingName: null,
    otherTradingId: null,
    tradingId: 'T202504220000010',
    tradingFlowId: '2',
    tradingName: 'AK_20250422',
    tradingManageName: 'Flow Two',
    tradeTypeCd: 1,
    tradeTypeCdDisplay: 1,
    tradingSubmitStatusCd: 2,
    tradingProgressStatusCd: 1,
    ownerSectionId: 'SE00000713',
    ownerSectionShortName: 'Sec1',
    ownerSectionName: 'Sec1',
    ownerCompanyId: 'CO00000262',
    ownerCompanyShortName: 'Exporter1_forDevCS',
    ownerCompanyName: 'Exporter1_forDevCS',
    ownerCompanyIcon: '/files/tw/companies/default/icon.png',
    flowCreateDate: '2025-04-23T02:03:36Z',
    flowUpdateDate: '2025-05-21T00:29:25Z',
    editableFlg: 1,
    deletableFlg: 0,
    visibleFlg: 1,
    flowDetailViewableFlg: 1,
    entityStatus: [
      {
        entityId: 'EEC000000013465',
        entityTypeCd: 3,
        entityProgressStatusCd: 1,
        no: null,
        processStatus: [
          {
            processId: 'ECREQ01',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 1,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [],
      },
      {
        entityId: 'ETP000000008314',
        entityTypeCd: 5,
        entityProgressStatusCd: 1,
        no: null,
        processStatus: [
          {
            processId: 'TPRB',
            processSeq: 1,
            processSortNo: 705,
            processName: 'Request Booking',
            processType: 'PT_TPATPRB',
            processProgressStatusCd: 1,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202504220000010',
            prevTradingFlowId: '2',
            prevEntityId: 'EEC000000013465',
            prevEntityTypeCd: 3,
          },
        ],
      },
    ],
    subordinateInfo: {
      parentFlg: 0,
      subFlg: 0,
      combineFlg: 0,
      parentFlowInfo: [
        {
          parentTradingId: null,
          parentFlowId: null,
          mainCombineFlg: null,
        },
      ],
    },
    tradingChannelInfo: {
      flowType: null,
      tradingChannelNo: 'TC20250423000002',
    },
    invoiceNo: null,
    contractNo: null,
    contractDate: null,
    sellerName: null,
    buyerName: null,
    contractGroupOfGoods: null,
    contractTotalQuantity: null,
    contractTotalQuantityUnitId: null,
    contractQuantityUnit: null,
    contractTotalAmount: null,
    contractCurrencyId: null,
    paymentTermsCd: null,
    deliveryTermsCd: null,
    blDate: null,
    eta: null,
    dischargingEta: null,
    nameOfVessel: null,
    blNo: null,
    vesselBookingNo: null,
    numberOfContainers: null,
    dischargingCurrentEta: null,
    portOfLoadingName: null,
    portOfDischargingName: null,
    imRequestDeclarationDate: null,
    deliveryDate: null,
    devanningPlace: null,
    warehouse: null,
    freeTime: null,
    exRequestDeclarationDate: null,
    vanningDate: null,
    vanningPlace: null,
    cyCutDate: null,
  },
  {
    otherTradingFlg: 0,
    otherTradingName: null,
    otherTradingId: null,
    tradingId: 'T202505080000001',
    tradingFlowId: '1',
    tradingName: 'PB-1203_許可書Amendチェック',
    tradingManageName: '1',
    tradeTypeCd: 1,
    tradeTypeCdDisplay: 1,
    tradingSubmitStatusCd: 2,
    tradingProgressStatusCd: 1,
    ownerSectionId: 'SE00000713',
    ownerSectionShortName: 'Sec1',
    ownerSectionName: 'Sec1',
    ownerCompanyId: 'CO00000262',
    ownerCompanyShortName: 'Exporter1_forDevCS',
    ownerCompanyName: 'Exporter1_forDevCS',
    ownerCompanyIcon: '/files/tw/companies/default/icon.png',
    flowCreateDate: '2025-05-08T05:05:28Z',
    flowUpdateDate: '2025-05-20T00:51:02Z',
    editableFlg: 1,
    deletableFlg: 0,
    visibleFlg: 1,
    flowDetailViewableFlg: 1,
    entityStatus: [
      {
        entityId: 'EEC000000013511',
        entityTypeCd: 3,
        entityProgressStatusCd: 1,
        no: null,
        processStatus: [
          {
            processId: 'ECREQ01',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 1,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'ECPERMIT',
            processSeq: 1,
            processSortNo: 430,
            processName: 'Store Ex. Customs Permit',
            processType: 'PT_ECPERMIT',
            processProgressStatusCd: 1,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [],
      },
      {
        entityId: 'EIC000000010588',
        entityTypeCd: 7,
        entityProgressStatusCd: 1,
        no: null,
        processStatus: [
          {
            processId: 'ICREQ01',
            processSeq: 1,
            processSortNo: 900,
            processName: 'Imp. Instruction',
            processType: 'PT_ICREQ',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'ICPERMIT',
            processSeq: 1,
            processSortNo: 930,
            processName: 'Store Im. Customs Permit',
            processType: 'PT_ICPERMIT',
            processProgressStatusCd: 1,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202505080000001',
            prevTradingFlowId: '1',
            prevEntityId: 'EEC000000013511',
            prevEntityTypeCd: 3,
          },
        ],
      },
    ],
    subordinateInfo: {
      parentFlg: 0,
      subFlg: 0,
      combineFlg: 0,
      parentFlowInfo: [
        {
          parentTradingId: null,
          parentFlowId: null,
          mainCombineFlg: null,
        },
      ],
    },
    tradingChannelInfo: {
      flowType: null,
      tradingChannelNo: 'TC20250508000001',
    },
    invoiceNo: null,
    contractNo: null,
    contractDate: null,
    sellerName: null,
    buyerName: null,
    contractGroupOfGoods: null,
    contractTotalQuantity: null,
    contractTotalQuantityUnitId: null,
    contractQuantityUnit: null,
    contractTotalAmount: null,
    contractCurrencyId: null,
    paymentTermsCd: null,
    deliveryTermsCd: null,
    blDate: null,
    eta: null,
    dischargingEta: null,
    nameOfVessel: null,
    blNo: null,
    vesselBookingNo: null,
    numberOfContainers: null,
    dischargingCurrentEta: null,
    portOfLoadingName: null,
    portOfDischargingName: null,
    imRequestDeclarationDate: null,
    deliveryDate: null,
    devanningPlace: null,
    warehouse: null,
    freeTime: null,
    exRequestDeclarationDate: null,
    vanningDate: null,
    vanningPlace: null,
    cyCutDate: null,
  },
  {
    otherTradingFlg: 0,
    otherTradingName: null,
    otherTradingId: null,
    tradingId: 'T202505190000003',
    tradingFlowId: '1',
    tradingName: '全項目テスト',
    tradingManageName: '全プロセス全項目テスト',
    tradeTypeCd: 1,
    tradeTypeCdDisplay: 1,
    tradingSubmitStatusCd: 2,
    tradingProgressStatusCd: 1,
    ownerSectionId: 'SE00000713',
    ownerSectionShortName: 'Sec1',
    ownerSectionName: 'Sec1',
    ownerCompanyId: 'CO00000262',
    ownerCompanyShortName: 'Exporter1_forDevCS',
    ownerCompanyName: 'Exporter1_forDevCS',
    ownerCompanyIcon: '/files/tw/companies/default/icon.png',
    flowCreateDate: '2025-05-19T01:17:57Z',
    flowUpdateDate: '2025-05-19T06:20:47Z',
    editableFlg: 1,
    deletableFlg: 0,
    visibleFlg: 1,
    flowDetailViewableFlg: 1,
    entityStatus: [
      {
        entityId: 'ESC000000011141',
        entityTypeCd: 1,
        entityProgressStatusCd: 9,
        no: '11111111111111111111',
        processStatus: [
          {
            processId: 'COPO',
            processSeq: 1,
            processSortNo: 100,
            processName: 'Send Purchase Order',
            processType: 'PT_COPO',
            processProgressStatusCd: 6,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'COCOS',
            processSeq: 1,
            processSortNo: 110,
            processName: 'Issue Contract',
            processType: 'PT_COCOS',
            processProgressStatusCd: 6,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [],
      },
      {
        entityId: 'ELC000000001613',
        entityTypeCd: 2,
        entityProgressStatusCd: 9,
        no: 'EB22/A891/A908/A187/E354/J826/K9262',
        processStatus: [
          {
            processId: 'LCACCEPT',
            processSeq: 1,
            processSortNo: 210,
            processName: 'Store Letter of Credit',
            processType: 'PT_LCACCEPT',
            processProgressStatusCd: 6,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202505190000003',
            prevTradingFlowId: '1',
            prevEntityId: 'ESC000000011141',
            prevEntityTypeCd: 1,
          },
        ],
      },
      {
        entityId: 'EAG000000001216',
        entityTypeCd: 8,
        entityProgressStatusCd: 9,
        no: 'EB22/A891/A908/A187/E354/J826/K9262',
        processStatus: [
          {
            processId: 'TPARB',
            processSeq: 1,
            processSortNo: 320,
            processName: 'Prepare Shipment',
            processType: 'PT_TPATPRB',
            processProgressStatusCd: 6,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202505190000003',
            prevTradingFlowId: '1',
            prevEntityId: 'ELC000000001613',
            prevEntityTypeCd: 2,
          },
        ],
      },
      {
        entityId: 'EEC000000013628',
        entityTypeCd: 3,
        entityProgressStatusCd: 1,
        no: 'EB22/A891/A908/A187/E354/J826/K9262',
        processStatus: [
          {
            processId: 'ECREQ01',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 1,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'ECPERMIT',
            processSeq: 1,
            processSortNo: 430,
            processName: 'Store Ex. Customs Permit',
            processType: 'PT_ECPERMIT',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202505190000003',
            prevTradingFlowId: '1',
            prevEntityId: 'EAG000000001216',
            prevEntityTypeCd: 8,
          },
        ],
      },
      {
        entityId: 'ETP000000008431',
        entityTypeCd: 5,
        entityProgressStatusCd: 1,
        no: 'EB22/A891/A908/A187/E354/J826/K9262',
        processStatus: [
          {
            processId: 'TPRB',
            processSeq: 1,
            processSortNo: 705,
            processName: 'Request Booking',
            processType: 'PT_TPATPRB',
            processProgressStatusCd: 6,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'TPRBL',
            processSeq: 1,
            processSortNo: 710,
            processName: 'Request Bill of Lading',
            processType: 'PT_TPRBL',
            processProgressStatusCd: 3,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'TPBLI01',
            processSeq: 1,
            processSortNo: 720,
            processName: 'Bill of Lading Information',
            processType: 'PT_TPBLI',
            processProgressStatusCd: 2,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'TPBL',
            processSeq: 1,
            processSortNo: 740,
            processName: 'Store Bill of Lading',
            processType: 'PT_TPBL',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202505190000003',
            prevTradingFlowId: '1',
            prevEntityId: 'EEC000000013628',
            prevEntityTypeCd: 3,
          },
        ],
      },
      {
        entityId: 'EMI000000008610',
        entityTypeCd: 4,
        entityProgressStatusCd: 1,
        no: 'EB22/A891/A908/A187/E354/J826/K9262',
        processStatus: [
          {
            processId: 'MIRIP01',
            processSeq: 1,
            processSortNo: 500,
            processName: 'Request Insurance Policy',
            processType: 'PT_MIRIP',
            processProgressStatusCd: 3,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'MIIP',
            processSeq: 1,
            processSortNo: 520,
            processName: 'Store Insurance Policy',
            processType: 'PT_MIIP',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202505190000003',
            prevTradingFlowId: '1',
            prevEntityId: 'ETP000000008431',
            prevEntityTypeCd: 5,
          },
        ],
      },
      {
        entityId: 'EFD000000008227',
        entityTypeCd: 6,
        entityProgressStatusCd: 1,
        no: 'EB33/A891/A908/S029/D293/L876/J9872',
        processStatus: [
          {
            processId: 'FDCRTDOC',
            processSeq: 1,
            processSortNo: 810,
            processName: 'Create Shipping Documents',
            processType: 'PT_FDCRTDOC',
            processProgressStatusCd: 7,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'FDCOR01',
            processSeq: 1,
            processSortNo: 820,
            processName: 'Request Certificate of Origin',
            processType: 'PT_FDCOR',
            processProgressStatusCd: 1,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'FDCOI01',
            processSeq: 1,
            processSortNo: 821,
            processName: 'Issue Certificate of Origin',
            processType: 'PT_FDCOI',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'FDDOC',
            processSeq: 1,
            processSortNo: 830,
            processName: 'Send Shipping Documents',
            processType: 'PT_FDDOC',
            processProgressStatusCd: 6,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202505190000003',
            prevTradingFlowId: '1',
            prevEntityId: 'EMI000000008610',
            prevEntityTypeCd: 4,
          },
        ],
      },
      {
        entityId: 'EIC000000010653',
        entityTypeCd: 7,
        entityProgressStatusCd: 1,
        no: 'EB33/A891/A908/S029/D293/L876/J9872',
        processStatus: [
          {
            processId: 'ICREQ01',
            processSeq: 1,
            processSortNo: 900,
            processName: 'Imp. Instruction',
            processType: 'PT_ICREQ',
            processProgressStatusCd: 6,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'ICPERMIT',
            processSeq: 1,
            processSortNo: 930,
            processName: 'Store Im. Customs Permit',
            processType: 'PT_ICPERMIT',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202505190000003',
            prevTradingFlowId: '1',
            prevEntityId: 'EFD000000008227',
            prevEntityTypeCd: 6,
          },
        ],
      },
    ],
    subordinateInfo: {
      parentFlg: 0,
      subFlg: 0,
      combineFlg: 0,
      parentFlowInfo: [
        {
          parentTradingId: null,
          parentFlowId: null,
          mainCombineFlg: null,
        },
      ],
    },
    tradingChannelInfo: {
      flowType: null,
      tradingChannelNo: 'TC20250519000003',
    },
    invoiceNo: 'EB22/A891/A908/A187/E354/J826/K9262',
    contractNo: '11111111111111111111',
    contractDate: '2024-07-08',
    sellerName:
      'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa',
    buyerName:
      'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa',
    contractGroupOfGoods:
      'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa',
    contractTotalQuantity: 11111111111,
    contractTotalQuantityUnitId: 'BG',
    contractQuantityUnit: 'ssssssssssssssssssss',
    contractTotalAmount: 2222222222222,
    contractCurrencyId: 'AED',
    paymentTermsCd: 1,
    deliveryTermsCd: 'FCA',
    blDate: '2022-08-08',
    eta: '2024-07-08',
    dischargingEta: '2024-07-08',
    nameOfVessel: 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa',
    blNo: 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa',
    vesselBookingNo: 'A1000000000000000000',
    numberOfContainers: 100,
    dischargingCurrentEta: '2024-07-08',
    portOfLoadingName:
      'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa',
    portOfDischargingName:
      'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa',
    imRequestDeclarationDate: '2025-05-09',
    deliveryDate: '2024-07-08',
    devanningPlace: 'AABENRAA <DKAAB> ',
    warehouse:
      'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa',
    freeTime: '2025-05-02',
    exRequestDeclarationDate: '2024-07-08',
    vanningDate: '2024-07-08',
    vanningPlace:
      'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa',
    cyCutDate: '2024-07-08',
  },
  {
    otherTradingFlg: 0,
    otherTradingName: null,
    otherTradingId: null,
    tradingId: 'T202505150000002',
    tradingFlowId: '1',
    tradingName: 'IP',
    tradingManageName: '1',
    tradeTypeCd: 1,
    tradeTypeCdDisplay: 1,
    tradingSubmitStatusCd: 2,
    tradingProgressStatusCd: 1,
    ownerSectionId: 'SE00000713',
    ownerSectionShortName: 'Sec1',
    ownerSectionName: 'Sec1',
    ownerCompanyId: 'CO00000262',
    ownerCompanyShortName: 'Exporter1_forDevCS',
    ownerCompanyName: 'Exporter1_forDevCS',
    ownerCompanyIcon: '/files/tw/companies/default/icon.png',
    flowCreateDate: '2025-05-15T01:09:44Z',
    flowUpdateDate: '2025-05-15T01:10:25Z',
    editableFlg: 1,
    deletableFlg: 0,
    visibleFlg: 1,
    flowDetailViewableFlg: 1,
    entityStatus: [
      {
        entityId: 'EEC000000013598',
        entityTypeCd: 3,
        entityProgressStatusCd: 9,
        no: 'INV',
        processStatus: [
          {
            processId: 'ECREQ01',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 6,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [],
      },
      {
        entityId: 'EMI000000008592',
        entityTypeCd: 4,
        entityProgressStatusCd: 0,
        no: 'INV',
        processStatus: [
          {
            processId: 'MIRIP01',
            processSeq: 1,
            processSortNo: 500,
            processName: 'Request Insurance Policy',
            processType: 'PT_MIRIP',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202505150000002',
            prevTradingFlowId: '1',
            prevEntityId: 'EEC000000013598',
            prevEntityTypeCd: 3,
          },
        ],
      },
    ],
    subordinateInfo: {
      parentFlg: 0,
      subFlg: 0,
      combineFlg: 0,
      parentFlowInfo: [
        {
          parentTradingId: null,
          parentFlowId: null,
          mainCombineFlg: null,
        },
      ],
    },
    tradingChannelInfo: {
      flowType: null,
      tradingChannelNo: 'TC20250515000002',
    },
    invoiceNo: 'INV',
    contractNo: null,
    contractDate: null,
    sellerName: null,
    buyerName: null,
    contractGroupOfGoods: null,
    contractTotalQuantity: null,
    contractTotalQuantityUnitId: null,
    contractQuantityUnit: null,
    contractTotalAmount: null,
    contractCurrencyId: null,
    paymentTermsCd: null,
    deliveryTermsCd: 'CIF',
    blDate: null,
    eta: null,
    dischargingEta: null,
    nameOfVessel: null,
    blNo: null,
    vesselBookingNo: null,
    numberOfContainers: null,
    dischargingCurrentEta: null,
    portOfLoadingName: null,
    portOfDischargingName: null,
    imRequestDeclarationDate: null,
    deliveryDate: null,
    devanningPlace: null,
    warehouse: null,
    freeTime: null,
    exRequestDeclarationDate: null,
    vanningDate: null,
    vanningPlace: null,
    cyCutDate: null,
  },
  {
    otherTradingFlg: 0,
    otherTradingName: null,
    otherTradingId: null,
    tradingId: 'T202505140000003',
    tradingFlowId: '1',
    tradingName: '検証①',
    tradingManageName: '検証①',
    tradeTypeCd: 1,
    tradeTypeCdDisplay: 1,
    tradingSubmitStatusCd: 2,
    tradingProgressStatusCd: 1,
    ownerSectionId: 'SE00000713',
    ownerSectionShortName: 'Sec1',
    ownerSectionName: 'Sec1',
    ownerCompanyId: 'CO00000262',
    ownerCompanyShortName: 'Exporter1_forDevCS',
    ownerCompanyName: 'Exporter1_forDevCS',
    ownerCompanyIcon: '/files/tw/companies/default/icon.png',
    flowCreateDate: '2025-05-14T00:05:21Z',
    flowUpdateDate: '2025-05-14T00:12:58Z',
    editableFlg: 1,
    deletableFlg: 0,
    visibleFlg: 1,
    flowDetailViewableFlg: 1,
    entityStatus: [
      {
        entityId: 'ESC000000011103',
        entityTypeCd: 1,
        entityProgressStatusCd: 1,
        no: '20250514',
        processStatus: [
          {
            processId: 'COCOS',
            processSeq: 1,
            processSortNo: 110,
            processName: 'Issue Contract',
            processType: 'PT_COCOS',
            processProgressStatusCd: 3,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [],
      },
    ],
    subordinateInfo: {
      parentFlg: 1,
      subFlg: 0,
      combineFlg: 0,
      parentFlowInfo: [
        {
          parentTradingId: null,
          parentFlowId: null,
          mainCombineFlg: null,
        },
      ],
    },
    tradingChannelInfo: {
      flowType: null,
      tradingChannelNo: 'TC20250514000003',
    },
    invoiceNo: null,
    contractNo: '20250514',
    contractDate: null,
    sellerName: null,
    buyerName: null,
    contractGroupOfGoods: null,
    contractTotalQuantity: 100,
    contractTotalQuantityUnitId: 'KGM',
    contractQuantityUnit: 'KG',
    contractTotalAmount: null,
    contractCurrencyId: null,
    paymentTermsCd: null,
    deliveryTermsCd: null,
    blDate: null,
    eta: null,
    dischargingEta: null,
    nameOfVessel: null,
    blNo: null,
    vesselBookingNo: null,
    numberOfContainers: null,
    dischargingCurrentEta: null,
    portOfLoadingName: null,
    portOfDischargingName: null,
    imRequestDeclarationDate: null,
    deliveryDate: null,
    devanningPlace: null,
    warehouse: null,
    freeTime: null,
    exRequestDeclarationDate: null,
    vanningDate: null,
    vanningPlace: null,
    cyCutDate: null,
  },
  {
    otherTradingFlg: 0,
    otherTradingName: null,
    otherTradingId: null,
    tradingId: 'T202505140000003',
    tradingFlowId: '3',
    tradingName: '検証①',
    tradingManageName: '残数量①',
    tradeTypeCd: 1,
    tradeTypeCdDisplay: 1,
    tradingSubmitStatusCd: 2,
    tradingProgressStatusCd: 0,
    ownerSectionId: 'SE00000713',
    ownerSectionShortName: 'Sec1',
    ownerSectionName: 'Sec1',
    ownerCompanyId: 'CO00000262',
    ownerCompanyShortName: 'Exporter1_forDevCS',
    ownerCompanyName: 'Exporter1_forDevCS',
    ownerCompanyIcon: '/files/tw/companies/default/icon.png',
    flowCreateDate: '2025-05-14T00:07:58Z',
    flowUpdateDate: '2025-05-14T00:12:58Z',
    editableFlg: 1,
    deletableFlg: 0,
    visibleFlg: 1,
    flowDetailViewableFlg: 1,
    entityStatus: [
      {
        entityId: 'EEC000000013568',
        entityTypeCd: 3,
        entityProgressStatusCd: 0,
        no: null,
        processStatus: [
          {
            processId: 'ECREQ01',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202505140000004',
            prevTradingFlowId: '1',
            prevEntityId: 'ESC000000011104',
            prevEntityTypeCd: 1,
          },
          {
            prevTradingId: 'T202505140000003',
            prevTradingFlowId: '1',
            prevEntityId: 'ESC000000011103',
            prevEntityTypeCd: 1,
          },
        ],
      },
    ],
    subordinateInfo: {
      parentFlg: 0,
      subFlg: 1,
      combineFlg: 1,
      parentFlowInfo: [
        {
          parentTradingId: 'T202505140000004',
          parentFlowId: '1',
          mainCombineFlg: 0,
        },
        {
          parentTradingId: 'T202505140000003',
          parentFlowId: '1',
          mainCombineFlg: 1,
        },
      ],
    },
    tradingChannelInfo: {
      flowType: null,
      tradingChannelNo: 'TC20250514000003',
    },
    invoiceNo: null,
    contractNo: '20250514',
    contractDate: null,
    sellerName: null,
    buyerName: null,
    contractGroupOfGoods: null,
    contractTotalQuantity: null,
    contractTotalQuantityUnitId: 'KGM',
    contractQuantityUnit: 'KG',
    contractTotalAmount: null,
    contractCurrencyId: null,
    paymentTermsCd: null,
    deliveryTermsCd: null,
    blDate: null,
    eta: null,
    dischargingEta: null,
    nameOfVessel: null,
    blNo: null,
    vesselBookingNo: null,
    numberOfContainers: null,
    dischargingCurrentEta: null,
    portOfLoadingName: null,
    portOfDischargingName: null,
    imRequestDeclarationDate: null,
    deliveryDate: null,
    devanningPlace: null,
    warehouse: null,
    freeTime: null,
    exRequestDeclarationDate: null,
    vanningDate: null,
    vanningPlace: null,
    cyCutDate: null,
  },
  {
    otherTradingFlg: 0,
    otherTradingName: null,
    otherTradingId: null,
    tradingId: 'T202505140000003',
    tradingFlowId: '4',
    tradingName: '検証①',
    tradingManageName: '残数量③',
    tradeTypeCd: 1,
    tradeTypeCdDisplay: 1,
    tradingSubmitStatusCd: 2,
    tradingProgressStatusCd: 0,
    ownerSectionId: 'SE00000713',
    ownerSectionShortName: 'Sec1',
    ownerSectionName: 'Sec1',
    ownerCompanyId: 'CO00000262',
    ownerCompanyShortName: 'Exporter1_forDevCS',
    ownerCompanyName: 'Exporter1_forDevCS',
    ownerCompanyIcon: '/files/tw/companies/default/icon.png',
    flowCreateDate: '2025-05-14T00:08:39Z',
    flowUpdateDate: '2025-05-14T00:12:58Z',
    editableFlg: 1,
    deletableFlg: 0,
    visibleFlg: 1,
    flowDetailViewableFlg: 1,
    entityStatus: [
      {
        entityId: 'EEC000000013570',
        entityTypeCd: 3,
        entityProgressStatusCd: 0,
        no: null,
        processStatus: [
          {
            processId: 'ECREQ01',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202505140000003',
            prevTradingFlowId: '1',
            prevEntityId: 'ESC000000011103',
            prevEntityTypeCd: 1,
          },
          {
            prevTradingId: 'T202505140000004',
            prevTradingFlowId: '1',
            prevEntityId: 'ESC000000011104',
            prevEntityTypeCd: 1,
          },
        ],
      },
    ],
    subordinateInfo: {
      parentFlg: 0,
      subFlg: 1,
      combineFlg: 1,
      parentFlowInfo: [
        {
          parentTradingId: 'T202505140000003',
          parentFlowId: '1',
          mainCombineFlg: 1,
        },
        {
          parentTradingId: 'T202505140000004',
          parentFlowId: '1',
          mainCombineFlg: 0,
        },
      ],
    },
    tradingChannelInfo: {
      flowType: null,
      tradingChannelNo: 'TC20250514000003',
    },
    invoiceNo: null,
    contractNo: '20250514',
    contractDate: null,
    sellerName: null,
    buyerName: null,
    contractGroupOfGoods: null,
    contractTotalQuantity: null,
    contractTotalQuantityUnitId: 'KGM',
    contractQuantityUnit: 'KG',
    contractTotalAmount: null,
    contractCurrencyId: null,
    paymentTermsCd: null,
    deliveryTermsCd: null,
    blDate: null,
    eta: null,
    dischargingEta: null,
    nameOfVessel: null,
    blNo: null,
    vesselBookingNo: null,
    numberOfContainers: null,
    dischargingCurrentEta: null,
    portOfLoadingName: null,
    portOfDischargingName: null,
    imRequestDeclarationDate: null,
    deliveryDate: null,
    devanningPlace: null,
    warehouse: null,
    freeTime: null,
    exRequestDeclarationDate: null,
    vanningDate: null,
    vanningPlace: null,
    cyCutDate: null,
  },
  {
    otherTradingFlg: 0,
    otherTradingName: null,
    otherTradingId: null,
    tradingId: 'T202505140000003',
    tradingFlowId: '2',
    tradingName: '検証①',
    tradingManageName: '分納①',
    tradeTypeCd: 1,
    tradeTypeCdDisplay: 1,
    tradingSubmitStatusCd: 2,
    tradingProgressStatusCd: 0,
    ownerSectionId: 'SE00000713',
    ownerSectionShortName: 'Sec1',
    ownerSectionName: 'Sec1',
    ownerCompanyId: 'CO00000262',
    ownerCompanyShortName: 'Exporter1_forDevCS',
    ownerCompanyName: 'Exporter1_forDevCS',
    ownerCompanyIcon: '/files/tw/companies/default/icon.png',
    flowCreateDate: '2025-05-14T00:05:58Z',
    flowUpdateDate: '2025-05-14T00:12:58Z',
    editableFlg: 1,
    deletableFlg: 0,
    visibleFlg: 1,
    flowDetailViewableFlg: 1,
    entityStatus: [
      {
        entityId: 'EEC000000013565',
        entityTypeCd: 3,
        entityProgressStatusCd: 0,
        no: null,
        processStatus: [
          {
            processId: 'ECREQ01',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202505140000003',
            prevTradingFlowId: '1',
            prevEntityId: 'ESC000000011103',
            prevEntityTypeCd: 1,
          },
          {
            prevTradingId: 'T202505140000004',
            prevTradingFlowId: '1',
            prevEntityId: 'ESC000000011104',
            prevEntityTypeCd: 1,
          },
        ],
      },
    ],
    subordinateInfo: {
      parentFlg: 0,
      subFlg: 1,
      combineFlg: 1,
      parentFlowInfo: [
        {
          parentTradingId: 'T202505140000003',
          parentFlowId: '1',
          mainCombineFlg: 1,
        },
        {
          parentTradingId: 'T202505140000004',
          parentFlowId: '1',
          mainCombineFlg: 0,
        },
      ],
    },
    tradingChannelInfo: {
      flowType: null,
      tradingChannelNo: 'TC20250514000003',
    },
    invoiceNo: null,
    contractNo: '20250514',
    contractDate: null,
    sellerName: null,
    buyerName: null,
    contractGroupOfGoods: null,
    contractTotalQuantity: null,
    contractTotalQuantityUnitId: 'KGM',
    contractQuantityUnit: 'KG',
    contractTotalAmount: null,
    contractCurrencyId: null,
    paymentTermsCd: null,
    deliveryTermsCd: null,
    blDate: null,
    eta: null,
    dischargingEta: null,
    nameOfVessel: null,
    blNo: null,
    vesselBookingNo: null,
    numberOfContainers: null,
    dischargingCurrentEta: null,
    portOfLoadingName: null,
    portOfDischargingName: null,
    imRequestDeclarationDate: null,
    deliveryDate: null,
    devanningPlace: null,
    warehouse: null,
    freeTime: null,
    exRequestDeclarationDate: null,
    vanningDate: null,
    vanningPlace: null,
    cyCutDate: null,
  },
  {
    otherTradingFlg: 0,
    otherTradingName: null,
    otherTradingId: null,
    tradingId: 'T202505140000004',
    tradingFlowId: '1',
    tradingName: '検証②',
    tradingManageName: '検証②',
    tradeTypeCd: 1,
    tradeTypeCdDisplay: 1,
    tradingSubmitStatusCd: 2,
    tradingProgressStatusCd: 1,
    ownerSectionId: 'SE00000713',
    ownerSectionShortName: 'Sec1',
    ownerSectionName: 'Sec1',
    ownerCompanyId: 'CO00000262',
    ownerCompanyShortName: 'Exporter1_forDevCS',
    ownerCompanyName: 'Exporter1_forDevCS',
    ownerCompanyIcon: '/files/tw/companies/default/icon.png',
    flowCreateDate: '2025-05-14T00:06:39Z',
    flowUpdateDate: '2025-05-14T00:12:58Z',
    editableFlg: 1,
    deletableFlg: 0,
    visibleFlg: 1,
    flowDetailViewableFlg: 1,
    entityStatus: [
      {
        entityId: 'ESC000000011104',
        entityTypeCd: 1,
        entityProgressStatusCd: 1,
        no: '20250514',
        processStatus: [
          {
            processId: 'COCOS',
            processSeq: 1,
            processSortNo: 110,
            processName: 'Issue Contract',
            processType: 'PT_COCOS',
            processProgressStatusCd: 3,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [],
      },
    ],
    subordinateInfo: {
      parentFlg: 1,
      subFlg: 0,
      combineFlg: 0,
      parentFlowInfo: [
        {
          parentTradingId: null,
          parentFlowId: null,
          mainCombineFlg: null,
        },
      ],
    },
    tradingChannelInfo: {
      flowType: null,
      tradingChannelNo: 'TC20250514000004',
    },
    invoiceNo: null,
    contractNo: '20250514',
    contractDate: null,
    sellerName: null,
    buyerName: null,
    contractGroupOfGoods: null,
    contractTotalQuantity: 100,
    contractTotalQuantityUnitId: 'KGM',
    contractQuantityUnit: 'KG',
    contractTotalAmount: null,
    contractCurrencyId: null,
    paymentTermsCd: null,
    deliveryTermsCd: null,
    blDate: null,
    eta: null,
    dischargingEta: null,
    nameOfVessel: null,
    blNo: null,
    vesselBookingNo: null,
    numberOfContainers: null,
    dischargingCurrentEta: null,
    portOfLoadingName: null,
    portOfDischargingName: null,
    imRequestDeclarationDate: null,
    deliveryDate: null,
    devanningPlace: null,
    warehouse: null,
    freeTime: null,
    exRequestDeclarationDate: null,
    vanningDate: null,
    vanningPlace: null,
    cyCutDate: null,
  },
  {
    otherTradingFlg: 0,
    otherTradingName: null,
    otherTradingId: null,
    tradingId: 'T202505140000004',
    tradingFlowId: '4',
    tradingName: '検証②',
    tradingManageName: '残数量④',
    tradeTypeCd: 1,
    tradeTypeCdDisplay: 1,
    tradingSubmitStatusCd: 2,
    tradingProgressStatusCd: 0,
    ownerSectionId: 'SE00000713',
    ownerSectionShortName: 'Sec1',
    ownerSectionName: 'Sec1',
    ownerCompanyId: 'CO00000262',
    ownerCompanyShortName: 'Exporter1_forDevCS',
    ownerCompanyName: 'Exporter1_forDevCS',
    ownerCompanyIcon: '/files/tw/companies/default/icon.png',
    flowCreateDate: '2025-05-14T00:10:01Z',
    flowUpdateDate: '2025-05-14T00:12:58Z',
    editableFlg: 1,
    deletableFlg: 0,
    visibleFlg: 1,
    flowDetailViewableFlg: 1,
    entityStatus: [
      {
        entityId: 'EEC000000013571',
        entityTypeCd: 3,
        entityProgressStatusCd: 0,
        no: null,
        processStatus: [
          {
            processId: 'ECREQ01',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202505140000004',
            prevTradingFlowId: '1',
            prevEntityId: 'ESC000000011104',
            prevEntityTypeCd: 1,
          },
        ],
      },
    ],
    subordinateInfo: {
      parentFlg: 0,
      subFlg: 1,
      combineFlg: 0,
      parentFlowInfo: [
        {
          parentTradingId: 'T202505140000004',
          parentFlowId: '1',
          mainCombineFlg: 0,
        },
      ],
    },
    tradingChannelInfo: {
      flowType: null,
      tradingChannelNo: 'TC20250514000004',
    },
    invoiceNo: null,
    contractNo: '20250514',
    contractDate: null,
    sellerName: null,
    buyerName: null,
    contractGroupOfGoods: null,
    contractTotalQuantity: null,
    contractTotalQuantityUnitId: 'KGM',
    contractQuantityUnit: 'KG',
    contractTotalAmount: null,
    contractCurrencyId: null,
    paymentTermsCd: null,
    deliveryTermsCd: null,
    blDate: null,
    eta: null,
    dischargingEta: null,
    nameOfVessel: null,
    blNo: null,
    vesselBookingNo: null,
    numberOfContainers: null,
    dischargingCurrentEta: null,
    portOfLoadingName: null,
    portOfDischargingName: null,
    imRequestDeclarationDate: null,
    deliveryDate: null,
    devanningPlace: null,
    warehouse: null,
    freeTime: null,
    exRequestDeclarationDate: null,
    vanningDate: null,
    vanningPlace: null,
    cyCutDate: null,
  },
  {
    otherTradingFlg: 0,
    otherTradingName: null,
    otherTradingId: null,
    tradingId: 'T202505140000002',
    tradingFlowId: '1',
    tradingName: '分納・混載検証取引②',
    tradingManageName: '分納・混載検証取引②',
    tradeTypeCd: 1,
    tradeTypeCdDisplay: 1,
    tradingSubmitStatusCd: 2,
    tradingProgressStatusCd: 1,
    ownerSectionId: 'SE00000713',
    ownerSectionShortName: 'Sec1',
    ownerSectionName: 'Sec1',
    ownerCompanyId: 'CO00000262',
    ownerCompanyShortName: 'Exporter1_forDevCS',
    ownerCompanyName: 'Exporter1_forDevCS',
    ownerCompanyIcon: '/files/tw/companies/default/icon.png',
    flowCreateDate: '2025-05-13T23:48:31Z',
    flowUpdateDate: '2025-05-13T23:57:30Z',
    editableFlg: 1,
    deletableFlg: 0,
    visibleFlg: 1,
    flowDetailViewableFlg: 1,
    entityStatus: [
      {
        entityId: 'ESC000000011102',
        entityTypeCd: 1,
        entityProgressStatusCd: 1,
        no: '20250514',
        processStatus: [
          {
            processId: 'COCOS',
            processSeq: 1,
            processSortNo: 110,
            processName: 'Issue Contract',
            processType: 'PT_COCOS',
            processProgressStatusCd: 3,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [],
      },
    ],
    subordinateInfo: {
      parentFlg: 1,
      subFlg: 0,
      combineFlg: 0,
      parentFlowInfo: [
        {
          parentTradingId: null,
          parentFlowId: null,
          mainCombineFlg: null,
        },
      ],
    },
    tradingChannelInfo: {
      flowType: null,
      tradingChannelNo: 'TC20250514000002',
    },
    invoiceNo: null,
    contractNo: '20250514',
    contractDate: null,
    sellerName: null,
    buyerName: null,
    contractGroupOfGoods: null,
    contractTotalQuantity: 100,
    contractTotalQuantityUnitId: 'KGM',
    contractQuantityUnit: 'KG',
    contractTotalAmount: null,
    contractCurrencyId: null,
    paymentTermsCd: null,
    deliveryTermsCd: null,
    blDate: null,
    eta: null,
    dischargingEta: null,
    nameOfVessel: null,
    blNo: null,
    vesselBookingNo: null,
    numberOfContainers: null,
    dischargingCurrentEta: null,
    portOfLoadingName: null,
    portOfDischargingName: null,
    imRequestDeclarationDate: null,
    deliveryDate: null,
    devanningPlace: null,
    warehouse: null,
    freeTime: null,
    exRequestDeclarationDate: null,
    vanningDate: null,
    vanningPlace: null,
    cyCutDate: null,
  },
  {
    otherTradingFlg: 0,
    otherTradingName: null,
    otherTradingId: null,
    tradingId: 'T202505140000002',
    tradingFlowId: '3',
    tradingName: '分納・混載検証取引②',
    tradingManageName: '残数量②',
    tradeTypeCd: 1,
    tradeTypeCdDisplay: 1,
    tradingSubmitStatusCd: 2,
    tradingProgressStatusCd: 0,
    ownerSectionId: 'SE00000713',
    ownerSectionShortName: 'Sec1',
    ownerSectionName: 'Sec1',
    ownerCompanyId: 'CO00000262',
    ownerCompanyShortName: 'Exporter1_forDevCS',
    ownerCompanyName: 'Exporter1_forDevCS',
    ownerCompanyIcon: '/files/tw/companies/default/icon.png',
    flowCreateDate: '2025-05-13T23:53:38Z',
    flowUpdateDate: '2025-05-13T23:57:30Z',
    editableFlg: 1,
    deletableFlg: 0,
    visibleFlg: 1,
    flowDetailViewableFlg: 1,
    entityStatus: [
      {
        entityId: 'EEC000000013545',
        entityTypeCd: 3,
        entityProgressStatusCd: 0,
        no: null,
        processStatus: [
          {
            processId: 'ECREQ01',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202505140000002',
            prevTradingFlowId: '1',
            prevEntityId: 'ESC000000011102',
            prevEntityTypeCd: 1,
          },
        ],
      },
    ],
    subordinateInfo: {
      parentFlg: 0,
      subFlg: 1,
      combineFlg: 0,
      parentFlowInfo: [
        {
          parentTradingId: 'T202505140000002',
          parentFlowId: '1',
          mainCombineFlg: 0,
        },
      ],
    },
    tradingChannelInfo: {
      flowType: null,
      tradingChannelNo: 'TC20250514000002',
    },
    invoiceNo: null,
    contractNo: '20250514',
    contractDate: null,
    sellerName: null,
    buyerName: null,
    contractGroupOfGoods: null,
    contractTotalQuantity: null,
    contractTotalQuantityUnitId: 'KGM',
    contractQuantityUnit: 'KG',
    contractTotalAmount: null,
    contractCurrencyId: null,
    paymentTermsCd: null,
    deliveryTermsCd: null,
    blDate: null,
    eta: null,
    dischargingEta: null,
    nameOfVessel: null,
    blNo: null,
    vesselBookingNo: null,
    numberOfContainers: null,
    dischargingCurrentEta: null,
    portOfLoadingName: null,
    portOfDischargingName: null,
    imRequestDeclarationDate: null,
    deliveryDate: null,
    devanningPlace: null,
    warehouse: null,
    freeTime: null,
    exRequestDeclarationDate: null,
    vanningDate: null,
    vanningPlace: null,
    cyCutDate: null,
  },
  {
    otherTradingFlg: 0,
    otherTradingName: null,
    otherTradingId: null,
    tradingId: 'T202505140000001',
    tradingFlowId: '1',
    tradingName: '分納・混載検証取引①',
    tradingManageName: '分納・混載検証取引①',
    tradeTypeCd: 1,
    tradeTypeCdDisplay: 1,
    tradingSubmitStatusCd: 2,
    tradingProgressStatusCd: 1,
    ownerSectionId: 'SE00000713',
    ownerSectionShortName: 'Sec1',
    ownerSectionName: 'Sec1',
    ownerCompanyId: 'CO00000262',
    ownerCompanyShortName: 'Exporter1_forDevCS',
    ownerCompanyName: 'Exporter1_forDevCS',
    ownerCompanyIcon: '/files/tw/companies/default/icon.png',
    flowCreateDate: '2025-05-13T23:46:14Z',
    flowUpdateDate: '2025-05-13T23:56:58Z',
    editableFlg: 1,
    deletableFlg: 0,
    visibleFlg: 1,
    flowDetailViewableFlg: 1,
    entityStatus: [
      {
        entityId: 'ESC000000011101',
        entityTypeCd: 1,
        entityProgressStatusCd: 1,
        no: '20250514',
        processStatus: [
          {
            processId: 'COCOS',
            processSeq: 1,
            processSortNo: 110,
            processName: 'Issue Contract',
            processType: 'PT_COCOS',
            processProgressStatusCd: 3,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [],
      },
    ],
    subordinateInfo: {
      parentFlg: 1,
      subFlg: 0,
      combineFlg: 0,
      parentFlowInfo: [
        {
          parentTradingId: null,
          parentFlowId: null,
          mainCombineFlg: null,
        },
      ],
    },
    tradingChannelInfo: {
      flowType: null,
      tradingChannelNo: 'TC20250514000001',
    },
    invoiceNo: null,
    contractNo: '20250514',
    contractDate: null,
    sellerName: null,
    buyerName: null,
    contractGroupOfGoods: null,
    contractTotalQuantity: 100,
    contractTotalQuantityUnitId: 'KGM',
    contractQuantityUnit: 'KG',
    contractTotalAmount: null,
    contractCurrencyId: null,
    paymentTermsCd: null,
    deliveryTermsCd: null,
    blDate: null,
    eta: null,
    dischargingEta: null,
    nameOfVessel: null,
    blNo: null,
    vesselBookingNo: null,
    numberOfContainers: null,
    dischargingCurrentEta: null,
    portOfLoadingName: null,
    portOfDischargingName: null,
    imRequestDeclarationDate: null,
    deliveryDate: null,
    devanningPlace: null,
    warehouse: null,
    freeTime: null,
    exRequestDeclarationDate: null,
    vanningDate: null,
    vanningPlace: null,
    cyCutDate: null,
  },
  {
    otherTradingFlg: 0,
    otherTradingName: null,
    otherTradingId: null,
    tradingId: 'T202505140000001',
    tradingFlowId: '3',
    tradingName: '分納・混載検証取引①',
    tradingManageName: '残数量①',
    tradeTypeCd: 1,
    tradeTypeCdDisplay: 1,
    tradingSubmitStatusCd: 2,
    tradingProgressStatusCd: 0,
    ownerSectionId: 'SE00000713',
    ownerSectionShortName: 'Sec1',
    ownerSectionName: 'Sec1',
    ownerCompanyId: 'CO00000262',
    ownerCompanyShortName: 'Exporter1_forDevCS',
    ownerCompanyName: 'Exporter1_forDevCS',
    ownerCompanyIcon: '/files/tw/companies/default/icon.png',
    flowCreateDate: '2025-05-13T23:53:38Z',
    flowUpdateDate: '2025-05-13T23:56:58Z',
    editableFlg: 1,
    deletableFlg: 0,
    visibleFlg: 1,
    flowDetailViewableFlg: 1,
    entityStatus: [
      {
        entityId: 'EEC000000013544',
        entityTypeCd: 3,
        entityProgressStatusCd: 0,
        no: null,
        processStatus: [
          {
            processId: 'ECREQ01',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202505140000001',
            prevTradingFlowId: '1',
            prevEntityId: 'ESC000000011101',
            prevEntityTypeCd: 1,
          },
        ],
      },
    ],
    subordinateInfo: {
      parentFlg: 0,
      subFlg: 1,
      combineFlg: 0,
      parentFlowInfo: [
        {
          parentTradingId: 'T202505140000001',
          parentFlowId: '1',
          mainCombineFlg: 0,
        },
      ],
    },
    tradingChannelInfo: {
      flowType: null,
      tradingChannelNo: 'TC20250514000001',
    },
    invoiceNo: null,
    contractNo: '20250514',
    contractDate: null,
    sellerName: null,
    buyerName: null,
    contractGroupOfGoods: null,
    contractTotalQuantity: null,
    contractTotalQuantityUnitId: 'KGM',
    contractQuantityUnit: 'KG',
    contractTotalAmount: null,
    contractCurrencyId: null,
    paymentTermsCd: null,
    deliveryTermsCd: null,
    blDate: null,
    eta: null,
    dischargingEta: null,
    nameOfVessel: null,
    blNo: null,
    vesselBookingNo: null,
    numberOfContainers: null,
    dischargingCurrentEta: null,
    portOfLoadingName: null,
    portOfDischargingName: null,
    imRequestDeclarationDate: null,
    deliveryDate: null,
    devanningPlace: null,
    warehouse: null,
    freeTime: null,
    exRequestDeclarationDate: null,
    vanningDate: null,
    vanningPlace: null,
    cyCutDate: null,
  },
  {
    otherTradingFlg: 0,
    otherTradingName: null,
    otherTradingId: null,
    tradingId: 'T202505140000001',
    tradingFlowId: '2',
    tradingName: '分納・混載検証取引①',
    tradingManageName: '分納フロー①',
    tradeTypeCd: 1,
    tradeTypeCdDisplay: 1,
    tradingSubmitStatusCd: 2,
    tradingProgressStatusCd: 0,
    ownerSectionId: 'SE00000713',
    ownerSectionShortName: 'Sec1',
    ownerSectionName: 'Sec1',
    ownerCompanyId: 'CO00000262',
    ownerCompanyShortName: 'Exporter1_forDevCS',
    ownerCompanyName: 'Exporter1_forDevCS',
    ownerCompanyIcon: '/files/tw/companies/default/icon.png',
    flowCreateDate: '2025-05-13T23:52:07Z',
    flowUpdateDate: '2025-05-13T23:56:58Z',
    editableFlg: 1,
    deletableFlg: 0,
    visibleFlg: 1,
    flowDetailViewableFlg: 1,
    entityStatus: [
      {
        entityId: 'EEC000000013542',
        entityTypeCd: 3,
        entityProgressStatusCd: 0,
        no: null,
        processStatus: [
          {
            processId: 'ECREQ01',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [
          {
            prevTradingId: 'T202505140000001',
            prevTradingFlowId: '1',
            prevEntityId: 'ESC000000011101',
            prevEntityTypeCd: 1,
          },
          {
            prevTradingId: 'T202505140000002',
            prevTradingFlowId: '1',
            prevEntityId: 'ESC000000011102',
            prevEntityTypeCd: 1,
          },
        ],
      },
    ],
    subordinateInfo: {
      parentFlg: 0,
      subFlg: 1,
      combineFlg: 1,
      parentFlowInfo: [
        {
          parentTradingId: 'T202505140000001',
          parentFlowId: '1',
          mainCombineFlg: 1,
        },
        {
          parentTradingId: 'T202505140000002',
          parentFlowId: '1',
          mainCombineFlg: 0,
        },
      ],
    },
    tradingChannelInfo: {
      flowType: null,
      tradingChannelNo: 'TC20250514000001',
    },
    invoiceNo: null,
    contractNo: '20250514',
    contractDate: null,
    sellerName: null,
    buyerName: null,
    contractGroupOfGoods: null,
    contractTotalQuantity: null,
    contractTotalQuantityUnitId: 'KGM',
    contractQuantityUnit: 'KG',
    contractTotalAmount: null,
    contractCurrencyId: null,
    paymentTermsCd: null,
    deliveryTermsCd: null,
    blDate: null,
    eta: null,
    dischargingEta: null,
    nameOfVessel: null,
    blNo: null,
    vesselBookingNo: null,
    numberOfContainers: null,
    dischargingCurrentEta: null,
    portOfLoadingName: null,
    portOfDischargingName: null,
    imRequestDeclarationDate: null,
    deliveryDate: null,
    devanningPlace: null,
    warehouse: null,
    freeTime: null,
    exRequestDeclarationDate: null,
    vanningDate: null,
    vanningPlace: null,
    cyCutDate: null,
  },
  {
    otherTradingFlg: 0,
    otherTradingName: null,
    otherTradingId: null,
    tradingId: 'T202505070000001',
    tradingFlowId: '3',
    tradingName: 'Sample1',
    tradingManageName: '3',
    tradeTypeCd: 1,
    tradeTypeCdDisplay: 1,
    tradingSubmitStatusCd: 2,
    tradingProgressStatusCd: 1,
    ownerSectionId: 'SE00000713',
    ownerSectionShortName: 'Sec1',
    ownerSectionName: 'Sec1',
    ownerCompanyId: 'CO00000262',
    ownerCompanyShortName: 'Exporter1_forDevCS',
    ownerCompanyName: 'Exporter1_forDevCS',
    ownerCompanyIcon: '/files/tw/companies/default/icon.png',
    flowCreateDate: '2025-05-13T07:28:21Z',
    flowUpdateDate: '2025-05-13T23:28:37Z',
    editableFlg: 1,
    deletableFlg: 0,
    visibleFlg: 1,
    flowDetailViewableFlg: 1,
    entityStatus: [
      {
        entityId: 'EEC000000013538',
        entityTypeCd: 3,
        entityProgressStatusCd: 1,
        no: '1234',
        processStatus: [
          {
            processId: 'ECREQ03',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'ECREQ02',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 3,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'ECREQ01',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 3,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [],
      },
    ],
    subordinateInfo: {
      parentFlg: 0,
      subFlg: 0,
      combineFlg: 0,
      parentFlowInfo: [
        {
          parentTradingId: null,
          parentFlowId: null,
          mainCombineFlg: null,
        },
      ],
    },
    tradingChannelInfo: {
      flowType: null,
      tradingChannelNo: 'TC20250513000012',
    },
    invoiceNo: '1234',
    contractNo: null,
    contractDate: null,
    sellerName: null,
    buyerName: null,
    contractGroupOfGoods: null,
    contractTotalQuantity: null,
    contractTotalQuantityUnitId: null,
    contractQuantityUnit: null,
    contractTotalAmount: null,
    contractCurrencyId: null,
    paymentTermsCd: null,
    deliveryTermsCd: null,
    blDate: null,
    eta: null,
    dischargingEta: null,
    nameOfVessel: null,
    blNo: null,
    vesselBookingNo: null,
    numberOfContainers: null,
    dischargingCurrentEta: null,
    portOfLoadingName: null,
    portOfDischargingName: null,
    imRequestDeclarationDate: null,
    deliveryDate: null,
    devanningPlace: null,
    warehouse: null,
    freeTime: null,
    exRequestDeclarationDate: null,
    vanningDate: null,
    vanningPlace: null,
    cyCutDate: null,
  },
  {
    otherTradingFlg: 0,
    otherTradingName: null,
    otherTradingId: null,
    tradingId: 'T202505070000001',
    tradingFlowId: '2',
    tradingName: 'Sample1',
    tradingManageName: '2',
    tradeTypeCd: 1,
    tradeTypeCdDisplay: 1,
    tradingSubmitStatusCd: 2,
    tradingProgressStatusCd: 1,
    ownerSectionId: 'SE00000713',
    ownerSectionShortName: 'Sec1',
    ownerSectionName: 'Sec1',
    ownerCompanyId: 'CO00000262',
    ownerCompanyShortName: 'Exporter1_forDevCS',
    ownerCompanyName: 'Exporter1_forDevCS',
    ownerCompanyIcon: '/files/tw/companies/default/icon.png',
    flowCreateDate: '2025-05-13T07:28:21Z',
    flowUpdateDate: '2025-05-13T23:24:25Z',
    editableFlg: 1,
    deletableFlg: 0,
    visibleFlg: 1,
    flowDetailViewableFlg: 1,
    entityStatus: [
      {
        entityId: 'EEC000000013537',
        entityTypeCd: 3,
        entityProgressStatusCd: 1,
        no: '1234',
        processStatus: [
          {
            processId: 'ECREQ01',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 3,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'ECREQ02',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 3,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'ECREQ03',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [],
      },
    ],
    subordinateInfo: {
      parentFlg: 0,
      subFlg: 0,
      combineFlg: 0,
      parentFlowInfo: [
        {
          parentTradingId: null,
          parentFlowId: null,
          mainCombineFlg: null,
        },
      ],
    },
    tradingChannelInfo: {
      flowType: null,
      tradingChannelNo: 'TC20250513000011',
    },
    invoiceNo: '1234',
    contractNo: null,
    contractDate: null,
    sellerName: null,
    buyerName: null,
    contractGroupOfGoods: null,
    contractTotalQuantity: null,
    contractTotalQuantityUnitId: null,
    contractQuantityUnit: null,
    contractTotalAmount: null,
    contractCurrencyId: null,
    paymentTermsCd: null,
    deliveryTermsCd: null,
    blDate: null,
    eta: null,
    dischargingEta: null,
    nameOfVessel: null,
    blNo: null,
    vesselBookingNo: null,
    numberOfContainers: null,
    dischargingCurrentEta: null,
    portOfLoadingName: null,
    portOfDischargingName: null,
    imRequestDeclarationDate: null,
    deliveryDate: null,
    devanningPlace: null,
    warehouse: null,
    freeTime: null,
    exRequestDeclarationDate: null,
    vanningDate: null,
    vanningPlace: null,
    cyCutDate: null,
  },
  {
    otherTradingFlg: 0,
    otherTradingName: null,
    otherTradingId: null,
    tradingId: 'T202505070000001',
    tradingFlowId: '1',
    tradingName: 'Sample1',
    tradingManageName: '1',
    tradeTypeCd: 1,
    tradeTypeCdDisplay: 1,
    tradingSubmitStatusCd: 2,
    tradingProgressStatusCd: 1,
    ownerSectionId: 'SE00000713',
    ownerSectionShortName: 'Sec1',
    ownerSectionName: 'Sec1',
    ownerCompanyId: 'CO00000262',
    ownerCompanyShortName: 'Exporter1_forDevCS',
    ownerCompanyName: 'Exporter1_forDevCS',
    ownerCompanyIcon: '/files/tw/companies/default/icon.png',
    flowCreateDate: '2025-05-07T00:12:00Z',
    flowUpdateDate: '2025-05-13T07:28:44Z',
    editableFlg: 1,
    deletableFlg: 0,
    visibleFlg: 1,
    flowDetailViewableFlg: 1,
    entityStatus: [
      {
        entityId: 'EEC000000013498',
        entityTypeCd: 3,
        entityProgressStatusCd: 1,
        no: '1234',
        processStatus: [
          {
            processId: 'ECREQ02',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 3,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'ECREQ03',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'ECREQ01',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 1,
            eventCancel: 0,
            editableFlg: 0,
            deletableFlg: 0,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [],
      },
    ],
    subordinateInfo: {
      parentFlg: 0,
      subFlg: 0,
      combineFlg: 0,
      parentFlowInfo: [
        {
          parentTradingId: null,
          parentFlowId: null,
          mainCombineFlg: null,
        },
      ],
    },
    tradingChannelInfo: {
      flowType: null,
      tradingChannelNo: 'TC20250507000001',
    },
    invoiceNo: '1234',
    contractNo: null,
    contractDate: null,
    sellerName: null,
    buyerName: null,
    contractGroupOfGoods: null,
    contractTotalQuantity: null,
    contractTotalQuantityUnitId: null,
    contractQuantityUnit: null,
    contractTotalAmount: null,
    contractCurrencyId: null,
    paymentTermsCd: null,
    deliveryTermsCd: null,
    blDate: null,
    eta: null,
    dischargingEta: null,
    nameOfVessel: null,
    blNo: null,
    vesselBookingNo: null,
    numberOfContainers: null,
    dischargingCurrentEta: null,
    portOfLoadingName: null,
    portOfDischargingName: null,
    imRequestDeclarationDate: null,
    deliveryDate: null,
    devanningPlace: null,
    warehouse: null,
    freeTime: null,
    exRequestDeclarationDate: null,
    vanningDate: null,
    vanningPlace: null,
    cyCutDate: null,
  },
  {
    otherTradingFlg: 0,
    otherTradingName: null,
    otherTradingId: null,
    tradingId: 'T202505070000001',
    tradingFlowId: '4',
    tradingName: 'Sample1',
    tradingManageName: '4',
    tradeTypeCd: 1,
    tradeTypeCdDisplay: 1,
    tradingSubmitStatusCd: 2,
    tradingProgressStatusCd: 0,
    ownerSectionId: 'SE00000713',
    ownerSectionShortName: 'Sec1',
    ownerSectionName: 'Sec1',
    ownerCompanyId: 'CO00000262',
    ownerCompanyShortName: 'Exporter1_forDevCS',
    ownerCompanyName: 'Exporter1_forDevCS',
    ownerCompanyIcon: '/files/tw/companies/default/icon.png',
    flowCreateDate: '2025-05-13T07:28:44Z',
    flowUpdateDate: '2025-05-13T07:28:44Z',
    editableFlg: 1,
    deletableFlg: 1,
    visibleFlg: 1,
    flowDetailViewableFlg: 1,
    entityStatus: [
      {
        entityId: 'EEC000000013539',
        entityTypeCd: 3,
        entityProgressStatusCd: 0,
        no: null,
        processStatus: [
          {
            processId: 'ECREQ03',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'ECREQ01',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
          {
            processId: 'ECREQ02',
            processSeq: 1,
            processSortNo: 400,
            processName: 'Exp. Shipping Instruction',
            processType: 'PT_ECREQ',
            processProgressStatusCd: 0,
            eventCancel: 0,
            editableFlg: 1,
            deletableFlg: 1,
            visibleFlg: 1,
            detailViewableFlg: 1,
          },
        ],
        prevEntityStatus: [],
      },
    ],
    subordinateInfo: {
      parentFlg: 0,
      subFlg: 0,
      combineFlg: 0,
      parentFlowInfo: [
        {
          parentTradingId: null,
          parentFlowId: null,
          mainCombineFlg: null,
        },
      ],
    },
    tradingChannelInfo: {
      flowType: null,
      tradingChannelNo: 'TC20250513000013',
    },
    invoiceNo: null,
    contractNo: null,
    contractDate: null,
    sellerName: null,
    buyerName: null,
    contractGroupOfGoods: null,
    contractTotalQuantity: null,
    contractTotalQuantityUnitId: null,
    contractQuantityUnit: null,
    contractTotalAmount: null,
    contractCurrencyId: null,
    paymentTermsCd: null,
    deliveryTermsCd: null,
    blDate: null,
    eta: null,
    dischargingEta: null,
    nameOfVessel: null,
    blNo: null,
    vesselBookingNo: null,
    numberOfContainers: null,
    dischargingCurrentEta: null,
    portOfLoadingName: null,
    portOfDischargingName: null,
    imRequestDeclarationDate: null,
    deliveryDate: null,
    devanningPlace: null,
    warehouse: null,
    freeTime: null,
    exRequestDeclarationDate: null,
    vanningDate: null,
    vanningPlace: null,
    cyCutDate: null,
  },
];
